<script lang="ts">
export default {
  name: 'Alert',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { X } from '@lucide/vue';

const props = withDefaults(
  defineProps<{
    type?: 'info' | 'success' | 'warning' | 'error';
    title?: string;
    closable?: boolean;
    icon?: any;
    class?: string;
  }>(),
  {
    type: 'info',
    closable: false,
  },
);

const emit = defineEmits<{
  close: [];
}>();

const typeClasses = {
  info: { alert: 'alert-info', button: 'btn-info' },
  success: { alert: 'alert-success', button: 'btn-success' },
  warning: { alert: 'alert-warning', button: 'btn-warning' },
  error: { alert: 'alert-error', button: 'btn-error' },
} as const;

const alertClasses = computed(() =>
  ['alert', typeClasses[props.type].alert, props.class].filter(Boolean).join(' '),
);

const closeButtonClasses = computed(
  () => `btn btn-square shrink-0 btn-ghost btn-sm ${typeClasses[props.type].button}`,
);

const handleClose = () => {
  emit('close');
};
</script>

<template>
  <div
    :class="alertClasses"
    class="flex items-center gap-2 py-0.5 text-xs font-bold">
    <div class="flex min-w-0 flex-1 items-center gap-2">
      <component
        v-if="icon"
        :is="icon"
        class="h-5 w-5 shrink-0" />
      <slot
        v-if="!icon && !title && !$slots.default"
        name="icon">
        <!-- Default icon based on type if no icon provided -->
      </slot>
      <div class="min-w-0 flex-1">
        <h3
          v-if="title"
          class="font-bold">
          {{ title }}
        </h3>
        <div>
          <slot />
        </div>
      </div>
    </div>
    <button
      v-if="closable"
      :class="closeButtonClasses"
      @click="handleClose">
      <X
        :size="16"
        class="h-4 w-4" />
    </button>
  </div>
</template>
